import api from '@/utils/api';

const VAPID_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
const ANON_KEY = 'push_anon_id';

function generateAnonId() {
  return 'xxxx-xxxx-xxxx'.replace(/x/g, () => Math.floor(Math.random() * 16).toString(16));
}

export function getAnonId() {
  let id = localStorage.getItem(ANON_KEY);
  if (!id) {
    id = generateAnonId();
    localStorage.setItem(ANON_KEY, id);
  }
  return id;
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function getPushPermission() {
  return Notification.permission;
}

export function isPushDismissed() {
  const ts = localStorage.getItem('push_dismissed_at');
  if (!ts) return false;
  const DAYS = 7;
  return (Date.now() - parseInt(ts)) < DAYS * 86400000;
}

export function dismissPush() {
  localStorage.setItem('push_dismissed_at', String(Date.now()));
}

export async function subscribePush() {
  if (!isPushSupported()) return null;

  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return null;

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_KEY),
    });
  }

  const subJson = sub.toJSON();
  const anonId = getAnonId();

  // Use public endpoint (no auth required)
  await api.post('/push/subscribe-public', {
    anon_id: anonId,
    subscription: {
      endpoint: subJson.endpoint,
      keys: {
        p256dh: subJson.keys.p256dh,
        auth: subJson.keys.auth,
      },
    },
  });

  return sub;
}

// Call after login to associate anonymous sub with user
export async function claimPushSubscription() {
  const anonId = localStorage.getItem(ANON_KEY);
  if (!anonId) return;
  try {
    await api.post('/push/claim', { anon_id: anonId });
  } catch { /* ignore */ }
}

export async function isCurrentlySubscribed() {
  if (!isPushSupported()) return false;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return !!sub;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
